import React from 'react';
import Container from '../../atoms/Container';
import Styles from './BlogDataFeitoPor.css';

function BlogDataFeitoPor({ data, feitopor, ...props }) {
  return (
    <>
      <article {...props} className="blog-data-feito-por">
        <Container extraPadding>
          {data && (
            <>
              <div className="data">
                <img src="../assets/shared/ic_calendar.svg" alt="calendário" />
                <p>{data}</p>
              </div>
            </>
          )}
          {feitopor && (
            <>
              <div className="feitoPor">
                <img src="../static/amp/shared/assets/ic_user.svg" alt="Pessoa" />
                <p>{feitopor}</p>
              </div>
            </>
          )}
        </Container>
      </article>
      <style jsx>{Styles}</style>
    </>
  );
}

export default BlogDataFeitoPor;
